import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Layout, Menu, Row, Col } from "antd";
import logo from "../../assets/image/logo/CyberReach.jpg";
import { menuItems } from "../../layouts/horizontalLayout";

const { Header } = Layout;

const CustomHeader = () => {
  const [current, setCurrent] = useState("home");

  const onClick = (e) => {
    console.log(e);
    setCurrent(e.key);
  };

  return (
    <Header style={{ background: "#fff", padding: 0 }}>
      <Row justify="space-between" align="middle" style={{ padding: "0 16px" }}>
        <Col>
          <Link to="/">
            <img
              src={logo}
              alt="CyberReach"
              style={{ height: 60, verticalAlign: "middle" }}
            />
          </Link>
        </Col>
        <Col flex="auto">
          <Menu
            onClick={onClick}
            selectedKeys={[current]}
            mode="horizontal"
            items={menuItems}
            style={{ justifyContent: "flex-end" }}
          />
        </Col>
      </Row>
    </Header>
  );
};

export default CustomHeader;
